export default {
	navigation: {
		individual: {
			label: 'Individual',
			menu_items: {
				online_shopping: 'Online Shopping',
				offline_kiosk: 'Offline Kiosk',
				pay_with_qr: 'Pay With QR Code',
				jpworldpay_creditcard: 'JP WORLD PAY Credit Card',
				transaction_cashback: 'Transaction & Cashback',
				send_asset: 'Send Asset',
				asset_request: 'Asset Request',
				get_deposit: 'Get A Deposit',
				fee: 'Fee',
				wallet: 'Wallet',
				account: 'Account',
				jpys: 'ADD JPYS',
				sell: 'Sell',
				exchanging_currency: 'Exchanging Currency',
			},
		},
		business: {
			label: 'Business',
			menu_items: {
				getting_Started: 'Getting Started',
				accepting_payment: 'Accepting Payment',
				make_a_payment: 'Make A Payment',
				risk_management: 'Risk Management',
				about_company: 'About Company',
				platforms_features: 'Platforms & Features',
				payment_method: 'Payment Method',
				global_payment: 'Global Payment',
				processing: 'Processing',
			},
		},
		development: {
			label: 'Development',
		},
		customer_service: {
			label: 'Customer Service',
		},
	},
	auth: {
		login: 'LOGIN',
		signup: 'SIGN UP',
	},
	accessibility: {
		toggle_navigation: 'Toggle navigation',
		logo_alt: 'Logo',
		language_selector: {
			alt: 'Language selector',
			current_language: 'English',
		},
	},
};
